module.exports = __webpack_public_path__ + "static/img/zanting.87ec2c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/zanting.png
// module id = NAMi
// module chunks = 24